import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import './Navbar.css';

export default function Navbar() {
  const { user, profile, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
    setDropdownOpen(false);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="navbar-inner container">
        <Link to="/" className="navbar-logo">
          <span className="logo-word-electra">ELEC</span>
          <span className="logo-word-dez">TRADEZ</span>
        </Link>

        <div className="navbar-links">
          <Link to="/listings" className={`nav-link ${isActive('/listings') ? 'active' : ''}`}>Browse</Link>
          <Link to="/bike-of-the-week" className={`nav-link ${isActive('/bike-of-the-week') ? 'active' : ''}`}>Bike of the Week</Link>
          {user && (
            <>
              <Link to="/sell" className={`nav-link ${isActive('/sell') ? 'active' : ''}`}>Sell</Link>
              <Link to="/messages" className={`nav-link ${isActive('/messages') ? 'active' : ''}`}>Messages</Link>
            </>
          )}
        </div>

        <div className="navbar-right">
          {user ? (
            <div className="user-menu" onClick={() => setDropdownOpen(!dropdownOpen)}>
              <div className="avatar">
                {profile?.avatar_url
                  ? <img src={profile.avatar_url} alt="avatar" />
                  : <span>{(profile?.username || 'U')[0].toUpperCase()}</span>
                }
              </div>
              <span className="username">{profile?.username}</span>
              <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor">
                <path d="M5 7L1 3h8L5 7z"/>
              </svg>
              {dropdownOpen && (
                <div className="dropdown">
                  <Link to="/my-listings" className="dropdown-item" onClick={() => setDropdownOpen(false)}>My Listings</Link>
                  <Link to="/messages" className="dropdown-item" onClick={() => setDropdownOpen(false)}>Messages</Link>
                  <Link to="/settings" className="dropdown-item" onClick={() => setDropdownOpen(false)}>Settings</Link>
                  <hr />
                  <button className="dropdown-item danger" onClick={handleSignOut}>Sign Out</button>
                </div>
              )}
            </div>
          ) : (
            <div className="auth-buttons">
              <Link to="/login" className="btn btn-ghost btn-sm">Log In</Link>
              <Link to="/signup" className="btn btn-primary btn-sm">Sign Up</Link>
            </div>
          )}
          <button className="mobile-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            <span/><span/><span/>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="mobile-menu">
          <Link to="/listings" onClick={() => setMenuOpen(false)}>Browse</Link>
          <Link to="/bike-of-the-week" onClick={() => setMenuOpen(false)}>Bike of the Week</Link>
          {user ? (
            <>
              <Link to="/sell" onClick={() => setMenuOpen(false)}>Sell</Link>
              <Link to="/messages" onClick={() => setMenuOpen(false)}>Messages</Link>
              <Link to="/settings" onClick={() => setMenuOpen(false)}>Settings</Link>
              <button onClick={handleSignOut}>Sign Out</button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setMenuOpen(false)}>Log In</Link>
              <Link to="/signup" onClick={() => setMenuOpen(false)}>Sign Up</Link>
            </>
          )}
        </div>
      )}
    </nav>
  );
}
